import { Upload, Tags, ReceiptText, Gauge, CheckCheck } from "lucide-react";
import { SectionHead, Reveal } from "./shared";

const STEPS = [
  { icon: Upload, title: "Cadastre ou importe seus lotes", desc: "Cada lote entra com custo de aquisição, despesas e mercadorias — pronto para ser gerido." },
  { icon: Tags, title: "Defina preços e acompanhe remarcações", desc: "Precifique com base no custo real e veja o efeito de cada remarcação na margem, em tempo real." },
  { icon: ReceiptText, title: "Registre vendas e despesas", desc: "Lançamentos rápidos alimentam os indicadores sem burocracia e sem retrabalho." },
  { icon: Gauge, title: "Visualize indicadores e desempenho", desc: "Projetado, realizado e potencial lado a lado: margem, ponto de equilíbrio e resultado em um painel." },
  { icon: CheckCheck, title: "Tome decisões mais seguras", desc: "Compra, preço, desconto e meta passam a ter fundamento — não sensação." },
];

export const HowItWorks = () => (
  <section id="como-funciona" data-testid="how-section" className="relative bg-tria-navy/50 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Na prática"
        testId="how-head"
        title={<>Como a TRIA funciona <span className="text-gradient-blue">na prática</span></>}
        sub="Cinco passos para sair do controle solto e chegar à gestão por indicadores."
      />

      <div className="relative mx-auto max-w-3xl">
        <div className="absolute bottom-8 left-[27px] top-8 w-px bg-gradient-to-b from-tria-sky/50 via-tria-blue/30 to-transparent sm:left-1/2" />
        <div className="flex flex-col gap-10">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.07}>
              <div
                data-testid={`how-step-${i + 1}`}
                className={`relative flex items-start gap-6 sm:w-1/2 ${i % 2 === 0 ? "sm:pr-12" : "sm:ml-auto sm:flex-row-reverse sm:pl-12 sm:text-right"}`}
              >
                <div className={`relative z-10 flex shrink-0 flex-col items-center ${i % 2 === 0 ? "sm:absolute sm:-right-[27px]" : "sm:absolute sm:-left-[27px]"} max-sm:order-first`}>
                  <span className="glow-blue flex h-14 w-14 items-center justify-center rounded-2xl border border-tria-sky/30 bg-tria-card text-tria-sky">
                    <s.icon className="h-6 w-6" />
                  </span>
                </div>
                <div className="group rounded-2xl border border-white/[0.07] bg-white/[0.02] p-6 transition-all duration-300 hover:border-tria-sky/30 hover:bg-tria-sky/[0.03]">
                  <span className="font-mono text-[10px] font-bold tracking-[0.25em] text-tria-blue">PASSO {String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-2 font-display text-lg font-semibold text-white">{s.title}</h3>
                  <p className="mt-2 text-[13.5px] leading-relaxed text-tria-mist">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
